var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-card',{staticClass:"bg-primary text-white pt-2 px-4"},[_c('div',{staticClass:"flex flex-col h-full gap-2"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h6',{staticClass:"text-white"},[_vm._v(_vm._s(_vm.title))])]),_c('p',{staticClass:"text-2xl font-bold"},[_vm._v(_vm._s(_vm.renderValue()))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }